module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<h2>Preferred shift</h2>\n<p>\n  ';
 if (positions.length > 1) { ;
__p += '\n  For each role below, please\n  ';
 } else { ;
__p += '\n  Please\n  ';
 } ;
__p += '\n  select your preferred shift start time from the available options.\n</p>\n\n<div class="app-step__preferred_shift">\n  ';
 positions.forEach(function(position) { ;
__p += '\n    <div class="app-step__preferred_shift-position">\n      <header>\n        <strong>' +
__e( position.title ) +
'</strong><br />\n        ' +
__e( position.company_name ) +
' - ' +
__e( position.location_name ) +
'\n      </header>\n      <select name="' +
__e( position.id ) +
'">\n        <option value="">Select...</option>\n        ';
 position.shifts.forEach(function(shift) { ;
__p += '\n          <option value="' +
__e( shift ) +
'"';
 if (position.pref_shift_start === shift) { ;
__p += ' selected';
 } ;
__p += '>\n            ' +
__e( shift ) +
'\n          </option>\n        ';
 }) ;
__p += '\n        <option value="Any"';
 if (position.pref_shift_start === 'Any') { ;
__p += ' selected';
 } ;
__p += '>\n          Any of these shifts is fine\n        </option>\n      </select>\n    </div>\n  ';
 }) ;
__p += '\n</div>\n';

}
return __p
}